import {ValueObject} from "../ValueObject";
import {IGuard} from "./Guard";
import {AppAnswerSet} from "../AppAnswerSet";



export class AndCondition extends ValueObject<IGuard[]> implements IGuard {


  isTrue(answers: AppAnswerSet): boolean {

    for( const guard of this.value ) {

      if( !guard.isTrue( answers )) {

        return false;
      }
    }

    return true;
  }

  protected onSetValue(value: IGuard[] | null) {
  }

  constructor( value: IGuard[] ) {

    super( value );
  }

}

